import { Radio, RadioSize } from "shared/components";

export const InvitationRadioType = ({
  type,
  title,
  description,
  checked,
  onChange,
  disabled
}: {
  type: "self-serve" | "manual";
  title: string;
  description: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}) => (
  <Radio
    disabled={disabled}
    className="!items-start gap-4"
    label={
      <div className="-mt-1">
        <p className="text-base font-medium text-content-700">{title}</p>
        <p className="text-sm text-content-400">{description}</p>
      </div>
    }
    checked={checked}
    onChange={onChange}
    id={type}
    name="application-type"
    size={RadioSize.LG}
  />
);
